import React, { useContext } from "react";
import cn from "classnames";
import Icon from "./Icon";
import { SettingsContext } from "../SettingsProvider";

import styles from "./ScaleControls.module.scss";

interface Props {
    scale: number;
    minScale: number;
    maxScale: number;
    onZoomIn: () => void;
    onZoomOut: () => void;
    onViewAll: () => void;
    onReset: () => void;
}

const ScaleControls: React.FC<Props> = function ({
    scale,
    minScale,
    maxScale,
    onZoomIn,
    onZoomOut,
    onViewAll,
    onReset
}: Props) {
    const { context } = useContext(SettingsContext);
    const dark = context.theme === "dark";

    return (
        <div className={cn(styles.controls, { [styles.dark]: dark })}>
            <Icon
                iconClass="icon__plus"
                className={cn(styles.icon, { [styles.disabled]: scale === maxScale })}
                onClick={onZoomIn}
            />
            <Icon
                iconClass="icon__minus"
                className={cn(styles.icon, { [styles.disabled]: scale === minScale })}
                onClick={onZoomOut}
            />
            <Icon iconClass="icon__showall" onClick={onViewAll} className={styles.icon} />
            <div onClick={onReset} className={cn(styles.scale, { [styles.disabled]: scale === 1.0 })}>
                {Math.round(scale * 10) / 10}x
            </div>
        </div>
    );
};

export default ScaleControls;
